export default function ListViewIcon({ size = 20, ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
            {...props}
        >
            <rect x="3.5" y="4.5" width="17" height="4" rx="1.5" />
            <rect x="3.5" y="10" width="17" height="4" rx="1.5" />
            <rect x="3.5" y="15.5" width="17" height="4" rx="1.5" />
        </svg>
    );
}
